import React from 'react';
import GridLoader from 'react-spinners/GridLoader';
import './LoadingTableBox.css';

function LoadingTableBox({ loading }) {
	return (
		<div className='loading-table-box-container'>
			<GridLoader color='#764176' loading={loading} />
		</div>
	);
}

export default LoadingTableBox;
